// Stub for react-native-google-mobile-ads on web — AdSenseBanner handles web ads instead
module.exports = {
  BannerAd: () => null,
  BannerAdSize: { BANNER: "BANNER" },
  InterstitialAd: {
    createForAdRequest: () => ({
      load: () => {},
      show: () => {},
      addAdEventListener: () => () => {},
    }),
  },
  RewardedAd: {
    createForAdRequest: () => ({
      load: () => {},
      show: () => {},
      addAdEventListener: () => () => {},
    }),
  },
  AdEventType: {},
  RewardedAdEventType: {},
  TestIds: {},
};
